import {
  FORECASTING_AC_LINE_LOSS_FAIL,
  FORECASTING_AC_LINE_LOSS_REQUEST,
  FORECASTING_AC_LINE_LOSS_RESET,
  FORECASTING_AC_LINE_LOSS_SUCCESS,
  FORECASTING_PR_FAIL,
  FORECASTING_PR_REQUEST,
  FORECASTING_PR_RESET,
  FORECASTING_PR_SUCCESS,
  FORECASTING_SCBSMBSTRING_DEVIATION_FAIL,
  FORECASTING_SCBSMBSTRING_DEVIATION_REQUEST,
  FORECASTING_SCBSMBSTRING_DEVIATION_RESET,
  FORECASTING_SCBSMBSTRING_DEVIATION_SUCCESS,
  FORECASTING_PLANT_AVAILABILITY_FAIL,
  FORECASTING_PLANT_AVAILABILITY_REQUEST,
  FORECASTING_PLANT_AVAILABILITY_RESET,
  FORECASTING_PLANT_AVAILABILITY_SUCCESS,
  FORECASTING_PLANT_AVAILABILITY_REQUEST2,
  FORECASTING_PLANT_AVAILABILITY_SUCCESS2,
  FORECASTING_PLANT_AVAILABILITY_FAIL2,
  FORECASTING_PLANT_AVAILABILITY_RESET2,
  FORECASTING_SOILING_LOSS_REQUEST,
  FORECASTING_SOILING_LOSS_RESET,
  FORECASTING_SOILING_LOSS_FAIL,
  FORECASTING_SOILING_LOSS_SUCCESS,
  FORECASTING_Transformer_TEMPERATURE_RESET,
  FORECASTING_Transformer_TEMPERATURE_FAIL,
  FORECASTING_Transformer_TEMPERATURE_SUCCESS,
  FORECASTING_Transformer_TEMPERATURE_REQUEST,
  FORECASTING_TRANSFORMER_TEMPERATURE_RESET,
  FORECASTING_TRANSFORMER_TEMPERATURE_FAIL,
  FORECASTING_TRANSFORMER_TEMPERATURE_SUCCESS,
  FORECASTING_TRANSFORMER_TEMPERATURE_REQUEST,
  FORECASTING_CABEL_INSULATION_WEAKENING_RESET,
  FORECASTING_CABEL_INSULATION_WEAKENING_FAIL,
  FORECASTING_CABEL_INSULATION_WEAKENING_SUCCESS,
  FORECASTING_CABEL_INSULATION_WEAKENING_REQUEST,
  FORECASTING_CONNECTOR_BOX_HEATING_RESET,
  FORECASTING_CONNECTOR_BOX_HEATING_FAIL,
  FORECASTING_CONNECTOR_BOX_HEATING_SUCCESS,
  FORECASTING_CONNECTOR_BOX_HEATING_REQUEST,
  FORECASTING_GALVANISATION_THICKNESS_REQUEST,
  FORECASTING_GALVANISATION_THICKNESS_SUCCESS,
  FORECASTING_GALVANISATION_THICKNESS_FAIL,
  FORECASTING_GALVANISATION_THICKNESS_RESET,
  FORECASTING_MODULE_HOTSPOT_RESET,
  FORECASTING_MODULE_HOTSPOT_FAIL,
  FORECASTING_MODULE_HOTSPOT_SUCCESS,
  FORECASTING_MODULE_HOTSPOT_REQUEST,
  FORECASTING_MODULE_DEGRADATION_RESET,
  FORECASTING_MODULE_DEGRADATION_FAIL,
  FORECASTING_MODULE_DEGRADATION_SUCCESS,
  FORECASTING_MODULE_DEGRADATION_REQUEST,
  FORECASTING_AC_CABEL_INSULATION_WEAKENING_REQUEST,
  FORECASTING_AC_CABEL_INSULATION_WEAKENING_SUCCESS,
  FORECASTING_AC_CABEL_INSULATION_WEAKENING_FAIL,
  FORECASTING_AC_CABEL_INSULATION_WEAKENING_RESET,
} from "../constants/ForecastingDataConstants";

export const forecasting = (
  state = {
    forecastedPr: null,
    forecastedAcLineLoss: null,
    forecastedScbsmbstringDeviation: null,
    forecastedPlantAvailability: null,
    forecastedPlantAvailability2: null,
    forecastedSoilingLoss: null,
    forecastedTransformerTemperature: null,
    forecastedCabelInsulationWeakening: null,
    forecastedAcCabelInsulationWeakening: null,
    forecastedBoxConnectorHeating: null,
    forecastedGalvanisationThickness: null,
    
  },
  action
) => {
  switch (action.type) {
    case FORECASTING_PR_REQUEST:
      return {
        ...state,
        prLoading: true,
        forecastedPr: null,
      };
    case FORECASTING_PR_SUCCESS:
      return {
        ...state,
        prLoading: false,
        forecastedPr: action.payload,
      };
    case FORECASTING_PR_FAIL:
      return {
        ...state,
        prLoading: false,
        error: action.payload,
      };
    case FORECASTING_PR_RESET:
      return {
        ...state,
        forecastedPr: null,
      };
    case FORECASTING_AC_LINE_LOSS_REQUEST:
      return {
        ...state,
        acLineLossLoading: true,
        forecastedAcLineLoss: null,
      };
    case FORECASTING_AC_LINE_LOSS_SUCCESS:
      return {
        ...state,
        acLineLossLoading: false,
        forecastedAcLineLoss: action.payload,
      };
    case FORECASTING_AC_LINE_LOSS_FAIL:
      return {
        ...state,
        acLineLossLoading: false,
        error: action.payload,
      };
    case FORECASTING_AC_LINE_LOSS_RESET:
      return {
        ...state,
        forecastedAcLineLoss: null,
      };

    case FORECASTING_SOILING_LOSS_REQUEST:
      return {
        ...state,
        soilingLossLoading: true,
        forecastedSoilingLoss: null,
      };
    case FORECASTING_SOILING_LOSS_SUCCESS:
      return {
        ...state,
        soilingLossLoading: false,
        forecastedSoilingLoss: action.payload,
      };
    case FORECASTING_SOILING_LOSS_FAIL:
      return {
        ...state,
        soilingLossLoading: false,
        error: action.payload,
      };
    case FORECASTING_SOILING_LOSS_RESET:
      return {
        ...state,
        forecastedSoilingLoss: null,
      };
    case FORECASTING_SCBSMBSTRING_DEVIATION_REQUEST:
      return {
        ...state,
        scbsmbstringDeviationLoading: true,
        forecastedScbsmbstringDeviation: null,
      };
    case FORECASTING_SCBSMBSTRING_DEVIATION_SUCCESS:
      return {
        ...state,
        scbsmbstringDeviationLoading: false,
        forecastedScbsmbstringDeviation: action.payload,
      };
    case FORECASTING_SCBSMBSTRING_DEVIATION_FAIL:
      return {
        ...state,
        scbsmbstringDeviationLoading: false,
        error: action.payload,
      };
    case FORECASTING_SCBSMBSTRING_DEVIATION_RESET:
      return {
        ...state,
        forecastedScbsmbstringDeviation: null,
      };

    case FORECASTING_PLANT_AVAILABILITY_REQUEST:
      return {
        ...state,
        plantAvailabilityLoading: true,
        forecastedPlantAvailability: null,
      };
    case FORECASTING_PLANT_AVAILABILITY_SUCCESS:
      return {
        ...state,
        plantAvailabilityLoading: false,
        forecastedPlantAvailability: action.payload,
      };
    case FORECASTING_PLANT_AVAILABILITY_FAIL:
      return {
        ...state,
        plantAvailabilityLoading: false,
        error: action.payload,
      };
    case FORECASTING_PLANT_AVAILABILITY_RESET:
      return {
        ...state,
        forecastedPlantAvailability: null,
      };

    case FORECASTING_PLANT_AVAILABILITY_REQUEST2:
      return {
        ...state,
        plantAvailabilityLoading2: true,
        forecastedPlantAvailability2: null,
      };
    case FORECASTING_PLANT_AVAILABILITY_SUCCESS2:
      return {
        ...state,
        plantAvailabilityLoading2: false,
        forecastedPlantAvailability2: action.payload,
      };
    case FORECASTING_PLANT_AVAILABILITY_FAIL2:
      return {
        ...state,
        plantAvailabilityLoading2: false,
        error: action.payload,
      };
    case FORECASTING_PLANT_AVAILABILITY_RESET2:
      return {
        ...state,
        forecastedPlantAvailability2: null,
      };

    case FORECASTING_TRANSFORMER_TEMPERATURE_REQUEST:
      return {
        ...state,
        transformerTemperatureLoading: true,
        forecastedTransformerTemperature: null,
      };
    case FORECASTING_TRANSFORMER_TEMPERATURE_SUCCESS:
      return {
        ...state,
        transformerTemperatureLoading: false,
        forecastedTransformerTemperature: action.payload,
      };
    case FORECASTING_TRANSFORMER_TEMPERATURE_FAIL:
      return {
        ...state,
        transformerTemperatureLoading: false,
        error: action.payload,
      };
    case FORECASTING_TRANSFORMER_TEMPERATURE_RESET:
      return {
        ...state,
        forecastedTransformerTemperature: null,
      };

  case FORECASTING_CABEL_INSULATION_WEAKENING_REQUEST:
      return {
        ...state,
        cabelInsulationWeakeningLoading: true,
        forecastedCabelInsulationWeakening: null,
      };
    case FORECASTING_CABEL_INSULATION_WEAKENING_SUCCESS:
      return {
        ...state,
        cabelInsulationWeakeningLoading: false,
        forecastedCabelInsulationWeakening: action.payload,
      };
    case FORECASTING_CABEL_INSULATION_WEAKENING_FAIL:
      return {
        ...state,
        cabelInsulationWeakeningLoading: false,
        error: action.payload,
      };
    case FORECASTING_CABEL_INSULATION_WEAKENING_RESET:
      return {
        ...state,
        forecastedCabelInsulationWeakening: null,
      };

  
    case FORECASTING_AC_CABEL_INSULATION_WEAKENING_REQUEST:
      return {
        ...state,
        acCabelInsulationWeakeningLoading: true,
        forecastedAcCabelInsulationWeakening: null,
      };
    case FORECASTING_AC_CABEL_INSULATION_WEAKENING_SUCCESS:
      return {
        ...state,
        acCabelInsulationWeakeningLoading: false,
        forecastedAcCabelInsulationWeakening: action.payload,
      };
    case FORECASTING_AC_CABEL_INSULATION_WEAKENING_FAIL:
      return {
        ...state,
        acCabelInsulationWeakeningLoading: false,
        error: action.payload,
      };
    case FORECASTING_AC_CABEL_INSULATION_WEAKENING_RESET:
      return {
        ...state,
        forecastedACCabelInsulationWeakening: null,
      };

    case FORECASTING_CONNECTOR_BOX_HEATING_REQUEST:
      return {
        ...state,
        boxConnectorHeatingLoading: true,
        forecastedBoxConnectorHeating: null,
      };
    case FORECASTING_CONNECTOR_BOX_HEATING_SUCCESS:
      return {
        ...state,
        boxConnectorHeatingLoading: false,
        forecastedBoxConnectorHeating: action.payload,
      };
    case FORECASTING_CONNECTOR_BOX_HEATING_FAIL:
      return {
        ...state,
        boxConnectorHeatingLoading: false,
        error: action.payload,
      };
    case FORECASTING_CONNECTOR_BOX_HEATING_RESET:
      return {
        ...state,
        forecastedBoxConnectorHeating: null,
      };

    case FORECASTING_GALVANISATION_THICKNESS_REQUEST:
      return {
        ...state,
        galvanisationThicknessLoading: true,
        forecastedGalvanisationThickness: null,
      };
    case FORECASTING_GALVANISATION_THICKNESS_SUCCESS:
      return {
        ...state,
        galvanisationThicknessLoading: false,
        forecastedGalvanisationThickness: action.payload,
      };
    case FORECASTING_GALVANISATION_THICKNESS_FAIL:
      return {
        ...state,
        galvanisationThicknessLoading: false,
        error: action.payload,
      };
    case FORECASTING_GALVANISATION_THICKNESS_RESET:
      return {
        ...state,
        forecastedGalvanisationThickness: null,
      };

    

    case FORECASTING_MODULE_DEGRADATION_REQUEST:
      return {
        ...state,
        moduleDegradationLoading: true,
        forecastedModuleDegradation: null,
      };
    case FORECASTING_MODULE_DEGRADATION_SUCCESS:
      return {
        ...state,
        moduleDegradationLoading: false,
        forecastedModuleDegradation: action.payload,
      };
    case FORECASTING_MODULE_DEGRADATION_FAIL:
      return {
        ...state,
        moduleDegradationLoading: false,
        error: action.payload,
      };
    case FORECASTING_MODULE_DEGRADATION_RESET:
      return {
        ...state,
        forecastedModuleDegradation: null,
      };



    case FORECASTING_MODULE_HOTSPOT_REQUEST:
      return {
        ...state,
        moduleHotspotLoading: true,
        forecastedModuleHotspot: null,
      };
    case FORECASTING_MODULE_HOTSPOT_SUCCESS:
      return {
        ...state,
        moduleHotspotLoading: false,
        forecastedModuleHotspot: action.payload,
      };
    case FORECASTING_MODULE_HOTSPOT_FAIL:
      return {
        ...state,
        moduleHotspotLoading: false,
        error: action.payload,
      };
    case FORECASTING_MODULE_HOTSPOT_RESET:
      return {
        ...state,
        forecastedModuleHotspot: null,
      };
    default:
      return state;
  }
};
